import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

// Fire-and-forget haptic feedback for the Capacitor iOS shell.
//
// No-op on web (Capacitor.isNativePlatform() is false there), so call sites
// never need their own platform guard. Every call swallows its rejection —
// haptics are a nicety, and a missing engine / denied permission must never
// throw into a React render, effect, or event handler.
//
// Exposed as plain functions (not just the useHaptics hook) so non-component
// modules — e.g. AuthContext's async login handlers, useViewTransitionLocation
// — can fire them too.
const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

// Subtle tick — navigation, tab switches, selection changes.
export function hapticLight() {
  if (!isNative()) return;
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}

// The "it worked" notification buzz — pairs with a success toast.
export function hapticSuccess() {
  if (!isNative()) return;
  Haptics.notification({ type: NotificationType.Success }).catch(() => {});
}
